import { render, staticRenderFns } from "./main.vue?vue&type=template&id=42cc44d2&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=42cc44d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cc44d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/websites/erp-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42cc44d2')) {
      api.createRecord('42cc44d2', component.options)
    } else {
      api.reload('42cc44d2', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=42cc44d2&scoped=true&", function () {
      api.rerender('42cc44d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/batEditor/main.vue"
export default component.exports